module.exports = __webpack_public_path__ + "static/media/ic_player_fullscreen copy.018cde9c.svg";